<!--
   Created by qing on 2022/5/19 下午9:54
   Des:
-->
<template>
  <div>
    <van-cell class="form-third-map-item" id="formThirdMapItem">
      <template slot="title">
        <span class="title"></span>
        <span style="color: red" v-if="!isRead && current.required">*</span>
      </template>
      <template slot="label">

        <template v-if="current.fieldHint">
          <froalaView v-if="$store.getters.newRtf" v-model="current.fieldHint"></froalaView>
          <div
            v-else
            class="ql-editor"
            v-html="current.fieldHint">
          </div>
        </template>


        <div ref="formThirdMapContainer" class="form-third-map-container" v-loading="fetchLoading">

          <div class="map-header" ref="mapHeader" v-if="current.showCurrentLocation === 'YES'">
            <div class="location-address-container">
              <div class="location-address-wrapper">
                定位地址：
                <span class="location-address">
            {{locationAddr}}
          </span>
              </div>
            </div>
            <div class="select-container">
              <div>
                附近
              </div>
              <div v-if="radius !== 'custom'" class="select" @click="radiusShow = true">
                {{radius}}米
              </div>
              <div v-if="radius === 'custom'" class="select" @click="radiusShow = true">
                自定义
              </div>
              <el-input
                v-if="radius === 'custom'"
                style="width: 140px; margin-right: 10px;"
                v-model.number="radiusInput"
                size="small"
                @change="radiusInputChange">
                <template slot="append">米</template>
              </el-input>
              <div>
                的数据
              </div>
            </div>
          </div>

          <div class="map__container-wrapper">
            <el-amap vid="bubbleAmap" ref="bubbleAmap" class="amap-demo">
            </el-amap>
          </div>
        </div>
      </template>
    </van-cell>

    <van-action-sheet
      v-model="radiusShow"
      title="选择范围"
      get-container="body"
      @select="onSelectRadius"
      :close-on-click-action="true"
      :actions="radiusOpts">
    </van-action-sheet>
  </div>
</template>


<script>
  import {current} from './mixin'
  import {formatDate, hexToRgba} from '../../../assets/js/Untis'
  import {FORM_STATUS__EDIT} from "../types";

  export default {
    mixins: [current],
    data() {
      return {
        radiusShow: false,
        timer: null,
        refreshTimer: null,
        fetchLoading: false,

        locationAddr: '',
        locationMarker: null,
        locationInfo: {
          latitude: 0,
          longitude: 0
        },
        radius: 3000,
        radiusInput: 3000,
        radiusOpts: [
          {
            name: '1000米',
            value: 1000
          },
          {
            name: '2000米',
            value: 2000
          },
          {
            name: '3000米',
            value: 3000
          },
          {
            name: '4000米',
            value: 4000
          },
          {
            name: '5000米',
            value: 5000
          },
          {
            name: '自定义',
            value: 'custom'
          },
        ],
        pointList: []
      }
    },
    computed: {

    },
    created() {
      if (this.current.root.status !== FORM_STATUS__EDIT) {
        this.fetchLoading = true
        document.addEventListener('FORM_FIELD_DATA_CHANGE', this.formFieldDataChange)
      }
    },
    mounted() {
      this.$nextTick(() => {

        if (this.$refs.formThirdMapContainer) {
          const contentWidth = document.querySelector(`#formThirdMapItem`).clientWidth
          console.log('contentWidth', contentWidth)
          if (this.current.lengthWidthScale === "1:1") {
            this.$refs.formThirdMapContainer.style.height = `${contentWidth}px`
          } else if (this.current.lengthWidthScale === "2:1") {
            this.$refs.formThirdMapContainer.style.height = `${contentWidth / 2}px`
          } else {
            this.$refs.formThirdMapContainer.style.height = `${contentWidth * 0.75}px`
          }
        }
        setTimeout(() => {
          console.log('AMapManager', this.$refs.bubbleAmap)
          this.getLocation()
        }, 1000)
      })
    },
    destroyed() {
      this.clearTimer()
      if (this.refreshTimer) {
        clearTimeout(this.refreshTimer)
        this.refreshTimer = null
      }
      document.removeEventListener('FORM_FIELD_DATA_CHANGE', this.formFieldDataChange)
    },
    methods: {
      clearTimer() {
        this.fetchLoading = false
        if (this.timer) {
          clearTimeout(this.timer)
          this.timer = null
        }
      },

      getLocation() {

        let map = null
        if (this.$refs.bubbleAmap) {
          map = this.$refs.bubbleAmap.$$getInstance()
        }
        console.log('getLocation', this.$refs.bubbleAmap, map)
        if (!map) {
          return
        }
        map.clearMap()
        this.map = map
        var geolocation = new AMap.Geolocation({
          enableHighAccuracy: true,//是否使用高精度定位，默认:true
          timeout: 10000,          //超过10秒后停止定位，默认：无穷大
          maximumAge: 0,           //定位结果缓存0毫秒，默认：0
          convert: true,           //自动偏移坐标，偏移后的坐标为高德坐标，默认：true
          showButton: true,        //显示定位按钮，默认：true
          buttonPosition: 'LB',    //定位按钮停靠位置，默认：'LB'，左下角
          buttonOffset: new AMap.Pixel(10, 20),//定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
          showMarker: false,        //定位成功后在定位到的位置显示点标记，默认：true
          showCircle: false,        //定位成功后用圆圈表示定位精度范围，默认：true
          panToLocation: true,     //定位成功后将定位到的位置作为地图中心点，默认：true
          zoomToAccuracy: true      //定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
        });
        map.addControl(geolocation);
        console.log(geolocation)
        geolocation.getCurrentPosition((status, result) => {
          console.log('result', status, result)
          if (status === 'complete') {//定位成功

            this.locationInfo.latitude = result.position.lat
            this.locationInfo.longitude = result.position.lng
            // const address = result.addressComponent
            if (this.current.showCurrentLocation === 'YES') {
              this.getAddress(result.position.lng, result.position.lat, (addRes) => {
                const address = addRes.regeocode.addressComponent
                this.locationAddr = address.province + address.city + address.district + address.township + address.street + address.streetNumber;
              })

              const icon = new AMap.Icon({
                size: new AMap.Size(24, 40),    // 图标尺寸
                image: 'https://api.pro.surongyun.cn/fs/file/download/516371809210204161',
                imageSize: new AMap.Size(24, 40)   // 根据所设置的大小拉伸或压缩图片
              });

              this.locationMarker = new AMap.Marker({
                position: new AMap.LngLat(this.locationInfo.longitude, this.locationInfo.latitude),
                icon: icon,
                offset: new AMap.Pixel(-26, -13),
                autoRotation: true,
                title: ''
              });
              map.add(this.locationMarker);
            }

            map.setCenter([this.locationInfo.longitude, this.locationInfo.latitude])

            this.autoRefresh()
          }
          map.setFitView();//根据地图上添加的覆盖物分布情况，自动缩放地图到合适的视野级别
          map.setZoom(Number(this.current.mapScale))
          if (status === 'error') {//定位失败
            if (result.info === 'NOT_SUPPORTED') {
              alert("当前浏览器不支持定位功能");
              return false;
            }
            if (result.info === 'FAILED') {
              var msg = result.message;
              if (msg.indexOf('Get ipLocation failed') !== -1) {
                // alert("IP精确定位失败");
                return false;
              }
              if (msg.indexOf('sdk定位失败') !== -1) {
                alert("请检查sdk的key是否设置好，以及webview的定位权限及应用和系统的定位权限是否开启");
                return false;
              }
              if (msg.indexOf('Browser not Support html5 geolocation') !== -1) {
                alert("浏览器不支持原生定位接口");
                return false;
              }
              if (msg.indexOf('Geolocation permission denied') !== -1) {
                alert("用户禁用了定位权限");
                return false;
              }
              if (msg.indexOf('Get geolocation time out') !== -1) {
                alert("浏览器定位超时");
                return false;
              }
              if (msg.indexOf('Get geolocation failed') !== -1) {
                alert("定位失败");
                return false;
              }
            }
          }
        });

        //地图加载失败
        map.on("error", function () {
          alert("地图加载失败，请重新进入页面或刷新当前页面重试");
        });

        const geocoder = new AMap.Geocoder({
          radius: 1000 //范围，默认：500
        });
        map.on('click', e => {
          console.log('click-----', e)
          // document.getElementById("lnglat").value = e.lnglat.getLng() + ',' + e.lnglat.getLat()
          this.locationMarker.setPosition(new AMap.LngLat(e.lnglat.getLng(), e.lnglat.getLat()))
          this.locationInfo.latitude = e.lnglat.getLat()
          this.locationInfo.longitude = e.lnglat.getLng()

          map.setCenter([e.lnglat.getLng(), e.lnglat.getLat()])
          map.setZoom(Number(this.current.mapScale))
          this.tableDataFetch()

          geocoder.getAddress(new AMap.LngLat(e.lnglat.getLng(), e.lnglat.getLat()), (status, result) => {
            if (status === 'complete' && result.regeocode) {
              this.locationAddr = result.regeocode.formattedAddress;
            } else {
              log.error('根据经纬度查询地址失败')
            }
          });
        });
      },
      getAddress(x, y, callback) {
        console.log('getAddress111',x, y)
        AMap.plugin(['AMap.Geocoder'], () => {
          let geocoder = new AMap.Geocoder({})
          // 109.07986,34.315921
          geocoder.getAddress([x, y], (status, result) => {
            if (status === 'complete' && result.regeocode) {
              // 处理返回结果
              if(callback) callback(result)
            } else {
              console.log('getAddress', status, result)
            }
          })
        })
      },

      onSelectRadius(opt) {
        this.radius = opt.value
        if (this.radius !== 'custom') {
          this.radiusInput = Number(this.radius)
        }
        this.tableDataFetch()
      },
      radiusInputChange() {
        this.tableDataFetch()
      },
      autoRefresh() {
        this.tableDataFetch()
        if (this.current.autoRefresh === 'YES') {
          this.refreshTimer = setTimeout(() => {
            this.autoRefresh()
          }, this.current.refreshFrequency * 1000)
        }
      },
      tableDataFetch() {
        this.clearTimer()
        const formSet = this.current.root
        this.fetchLoading  = true
        this.$store.dispatch('actionFormThirdMapData', {
          appId: formSet.appId, //appId
          formId: formSet.formId,  //表单的Id
          fieldId: this.current.dataId,
          data: formSet.getValues(),
          latitude: this.locationInfo.latitude,
          longitude: this.locationInfo.longitude,
          distance: this.radiusInput
        }).then(res => {
          this.timer = setTimeout(() => {
            this.tableDataCycle(res.taskId)
          }, 1000)
        }).catch(console.error)
          .finally(() => {
            this.fetchLoading  = false
          })
      },
      tableDataCycle(taskId) {
        this.clearTimer()
        this.$store.dispatch('actionFormThirdTableDataCycle', {
          taskId
        }).then(res => {
          if (res.executeFinish === 0) {
            this.timer = setTimeout(() => {
              this.tableDataCycle(res.taskId)
            }, 2000)
          } else if (res.executeFinish === 1){
            this.clearTimer()
            this.pointList = res.resultInfo.dataList
            this.setPoint()
          } else if (res.executeFinish === -1){
            this.clearTimer()
            this.$alert(res.errorMsg, '获取数据失败', {
              confirmButtonText: '确定',
              callback: action => {
              }
            });
          }
        }).catch(console.error)
      },

      setPoint() {
        console.log('setPoint', this.pointList)
        this.pointList.forEach(point => {

          if (point && point.latitude && point.longitude) {
            // 创建一个 Marker 实例： 34.33560887627616, lon: 108.94820553351279   108.94354, 34.33716

            let icon = ''
            if (point.iconUrl) {
              icon = new AMap.Icon({
                size: new AMap.Size(30, 30),    // 图标尺寸
                image: point.iconUrl,
                imageSize: new AMap.Size(30, 30)   // 根据所设置的大小拉伸或压缩图片
              });
            }
            const marker = new AMap.Marker({
              position: new AMap.LngLat(point.longitude, point.latitude),   // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
              title: point.bubbleContent,
              icon
            });

            let content = point.mapTitle
            if (point.mapTitle.length > 30) {
              content = point.mapTitle.slice(0, 30) + '...'
            }

            marker.setLabel({
              offset: new AMap.Pixel(0, 0),  //设置文本标注偏移量
              content: '<div class="info">' + `${content}` + '</div>', //设置文本标注内容
              direction: 'top' //设置文本标注方位
            });
            // 将创建的点标记添加到已有的地图实例：
            this.map.add(marker);

            marker.recordId = point.recordId
            marker.on('click', e => {
              console.log('click', e)
              const point = this.pointList.filter(item => item.recordId === e.target.recordId)[0]
              console.log('click', e, point)
              if (point) {
                const title = point.mapTitle
                const content = []

                point.showDataList.forEach(item => {
                  let value = ''
                  if (item.type === 'image') {
                    item.dataValue.slice(0, 3).forEach(url => {
                      value += "<img style='width: 20px; height: 20px' src=" + url + ">"
                    })
                  } else if (item.type === 'date') {
                    value = formatDate(item.dataValue)('yyyy/MM/dd HH:mm:ss')
                  } else {
                    value = item.dataValue
                  }
                  content.push("<div class='input-item'>" +
                    "<div class='title' style='color:" + item.titleColor + "'" +  ">" +  `${item.text}`+ "</div>" +
                    "：" +
                    "<div class='value' style='color:" + item.contentColor + "'" +  ">" +`${value}` + "</div>" +
                    "</div>")
                })

                const infoWindow = new AMap.InfoWindow({
                  // isCustom: true,  //使用自定义窗体
                  content: this.createInfoWindow(title, content.join("")),  //使用默认信息窗体框样式，显示信息内容
                  offset: new AMap.Pixel(0, -30),
                  closeWhenClickMap: true
                });

                infoWindow.open(this.map, marker.getPosition());
              }
            });
          }
          this.map.setZoom(Number(this.current.mapScale))
        })

        if (this.current.queryDataType === 'CURRENT_DATA' &&
          this.pointList.length) {
          const point = this.pointList[0]
          if (point.longitude && point.latitude) {
            this.map.setCenter([point.longitude, point.latitude])
          }
        }
      },
      createInfoWindow(title, content) {
        var info = document.createElement("div");
        info.className = "custom-info input-card content-window-card";

        //可以通过下面的方式修改自定义窗体的宽高
        info.style.width = "300px";
        // 定义顶部标题
        var top = document.createElement("div");
        var titleD = document.createElement("div");
        top.className = "info-top";
        titleD.innerHTML = title;

        top.appendChild(titleD);
        info.appendChild(top);

        // 定义中部内容
        var middle = document.createElement("div");
        middle.className = "info-middle";
        middle.innerHTML = content;
        info.appendChild(middle);

        return info;
      },

      closeInfoWindow() {
        this.map.clearInfoWindow();
      },

      formFieldDataChange(e) {

        if (e.detail) {
          const {
            fieldId,
            formId,
            rowIdx
          } = e.detail
          if (formId === this.current.root.formId && this.current.refreshFieldIdList.includes(fieldId)) {
            this.tableDataFetch()
          }
        }
      }
    }
  }
</script>

<style lang="less">

  .form-third-map-item {
    width: 100%;

    .form-third-map-container {
      width: 100%;
      min-height: 100px;
      height: 30vw;
      position: relative;

      .map-header {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        min-height: 60px;
        height: auto;
        background-color: #fff;
        padding: 5px;
        z-index: 2;
        font-size: 14px;
        box-shadow: 0 2px 4px 0 rgba(43, 52, 65, 0.1);

        .location-address-container {
          display: flex;
          flex-direction: column;

          .location-address-wrapper {

            .location-address {
              color: #3FB27E;
            }
          }

          .tips {
            font-size: 12px;
            color: #2d8cf0;
            margin-top: 5px;
          }
        }

        .select-container {
          display: flex;
          align-items: center;
          margin-top: 10px;

          .select {
            margin: 0 10px;
            color: #2d8cf0;

          }
        }
      }

      .map__container-wrapper {
        position: relative;
        width: 100%;
        height: 100%;

        .amap-marker-label {
          border: none;
          background-color: #1b9aee;
          color: #ffffff;
          border-radius: 4px;
        }
      }

      .amap-info-close {
        top: 15px;
      }

      .amap-info-content {
        backdrop-filter: blur(1px);
        background: rgba(255, 255, 255, 0.9);
      }
      .amap-info-sharp {

        &:after {
          /*backdrop-filter: blur(1px);*/
          /*background: rgba(255, 255, 255, 0.9);*/
        }

      }

      .content-window-card {
        position: relative;
        box-shadow: none;
        bottom: 0;
        left: 0;
        width: auto;
        padding: 0;

        .info-top {
          position: relative;
          border-bottom: 1px solid #CCC;
          border-radius: 5px 5px 0 0;
          margin-right: 20px;
        }

        .info-top div {
          display: inline-block;
          color: #333333;
          font-size: 14px;
          font-weight: bold;
          line-height: 21px;
        }

        .info-middle {
          font-size: 12px;
          padding: 10px 6px;
          line-height: 20px;

          .input-item {
            width: 100%;
            display: flex;

            .title {
              width: 30%;
              font-weight: 500;
              text-align: right;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
              word-wrap: break-word;
            }

            .value {
              width: 70%;
              display: flex;

              >img {
                margin-right: 10px;
              }
            }
          }
        }

        span {
          margin-left: 5px;
          font-size: 11px;
        }

        .info-middle img {
          float: left;
          margin-right: 6px;
        }
      }

      .content-window-card p {
        height: 2rem;
      }

      .custom-info {
        /*border: solid 1px silver;*/
      }
    }
  }
</style>

